import { OrderType } from '@exam-management/graphql';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';

import { defaultDataGridState } from '../../constants';
import type { UserListDataGridParams } from '../../provider';
import { UserStatus } from '../../types';

export function useUserListSearchParams(
  defaultValues: UserListDataGridParams = defaultDataGridState,
) {
  const { sort, field, page, pageSize, role } = defaultValues;
  return useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(page),
      pageSize: parseAsInteger.withDefault(pageSize),
      field: parseAsString.withDefault(field),
      sort: parseAsStringEnum<OrderType>(Object.values(OrderType)).withDefault(sort),
      status: parseAsStringEnum<UserStatus | ''>(Object.values(UserStatus)).withDefault(''),
      role: parseAsString.withDefault(role),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );
}
